import {
    DEALERSENDINCASHIN_FAILED,
    DEALERSENDINCASHIN_SUCCESS,
    RESET_DEALERSENDINCASHIN,
    LOADING_DEALERSENDINCASHIN,
    NETWORK_ERROR_DEALERSENDINCASHIN
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERSENDINCASHIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERSENDINCASHIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERSENDINCASHIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERSENDINCASHIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERSENDINCASHIN:
            return (state = initialState);
        default:
            return state;
    }
};